module.exports = __webpack_public_path__ + "img/img-item-a.3d74160e.png";